export default "__VITE_ASSET__D5xE2SWd__"